import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { GenericCrudService } from '../../../services/generic-crud.service';

export interface PaymentData {
  payment_method: string;
  pos_terminal_id: number | null;
  cash_amount: number | null;
  card_amount: number | null;
  valid: boolean;
}

@Component({
  selector: 'app-payment-method-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule],
  templateUrl: './payment-method-selector.component.html'
})
export class PaymentMethodSelectorComponent implements OnInit, OnChanges {
  @Input() totalAmount: number | null = null;
  @Input() fixedMethod: string | null = null;
  @Output() paymentDataChange = new EventEmitter<PaymentData>();

  paymentMethod: string = 'cash';
  posTerminalId: number | null = null;
  cashAmount: number | null = null;
  cardAmount: number | null = null;
  posTerminalsList: any[] = [];

  constructor(private genericCrudService: GenericCrudService) {}

  ngOnInit() {
    if (this.fixedMethod) {
      this.paymentMethod = this.fixedMethod;
    }
    this.genericCrudService.getSelectOptions('/config/pos-terminal/listAll').subscribe({
      next: res => { this.posTerminalsList = res.data || []; },
      error: () => { this.posTerminalsList = []; }
    });
    this.emitChange();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalAmount'] && !changes['totalAmount'].firstChange) {
      this.cashAmount = null;
      this.cardAmount = null;
      this.emitChange();
    }
  }

  selectMethod(method: string) {
    this.paymentMethod = method;
    if (method === 'cash') {
      this.posTerminalId = null;
      this.cashAmount = null;
      this.cardAmount = null;
    } else if (method === 'card') {
      this.cashAmount = null;
      this.cardAmount = null;
    }
    this.emitChange();
  }

  onPosTerminalChange() {
    this.emitChange();
  }

  onCashAmountChange() {
    if (this.totalAmount != null && this.cashAmount != null) {
      const card = +(this.totalAmount - +this.cashAmount).toFixed(2);
      this.cardAmount = card >= 0 ? card : 0;
    }
    this.emitChange();
  }

  onCardAmountChange() {
    if (this.totalAmount != null && this.cardAmount != null) {
      const cash = +(this.totalAmount - +this.cardAmount).toFixed(2);
      this.cashAmount = cash >= 0 ? cash : 0;
    }
    this.emitChange();
  }

  get splitAmountsValid(): boolean {
    if (this.totalAmount == null) return false;
    const sum = +(this.cashAmount || 0) + +(this.cardAmount || 0);
    return Math.abs(sum - +this.totalAmount) < 0.01;
  }

  get isValid(): boolean {
    if (!this.paymentMethod) return false;
    if (this.paymentMethod === 'card' || this.paymentMethod === 'split') {
      if (!this.posTerminalId) return false;
    }
    if (this.paymentMethod === 'split') {
      if (!this.splitAmountsValid) return false;
    }
    return true;
  }

  private emitChange() {
    this.paymentDataChange.emit({
      payment_method: this.paymentMethod,
      pos_terminal_id: (this.paymentMethod === 'card' || this.paymentMethod === 'split') ? this.posTerminalId : null,
      cash_amount: this.paymentMethod === 'split' ? this.cashAmount : null,
      card_amount: this.paymentMethod === 'split' ? this.cardAmount : null,
      valid: this.isValid
    });
  }
}
